var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcaseV2 = function SvgBriefcaseV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7 19V5c0-.93 0-1.395.102-1.776a3 3 0 0 1 2.122-2.122C9.605 1 10.07 1 11 1s1.395 0 1.777.102a3 3 0 0 1 2.12 2.122C15 3.605 15 4.07 15 5v14M4.2 19h13.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C21 17.48 21 16.92 21 15.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C19.48 5 18.92 5 17.8 5H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C1 6.52 1 7.08 1 8.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 19 3.08 19 4.2 19"
  })));
};
export default SvgBriefcaseV2;